module.exports = __webpack_public_path__ + "static/media/icon_95.202b2191.svg";